import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {RoleModel} from './role-model';

@Injectable({
  providedIn: 'root'
})
export class RolesService {
  private roles: RoleModel[];

  constructor(private httpClient: HttpClient) { }

  public get(): Observable<RoleModel[]> {
    if (this.roles != null) {
      return of<RoleModel[]>(this.roles);
    }

    return this.httpClient.get<RoleModel[]>('api/roles')
      .pipe(map(x => {
        this.roles = x;
        return x;
      }));
  }
}
